// import _ from 'lodash'
import ConfigAnalyze from '@/utils/ConfigAnalyze'
import ApiManager from '../../utils/ApiManager'
import Constants from '@/utils/Constants'

const state = {
  ConfigAnalyze: ConfigAnalyze,

  isInit: false,
  loading: false,
  // analyzeCode: null,
  // analyzeCodeMode: '',
  submit: {
    base: false,
    target: false
  },
  submitSearch: {
    base: false,
    target: false
  },
  //  店舗初期データ
  constData: {
    shop_area: [],
    shop_group: [],
    shopCategoryLevel: 1,
    shop_category: []
  },
  //  店舗分析再現パラメータ
  condition: {
  },
  //  店舗カート設定
  cartSettings: {
    labelName: 'name',
    keyName: 'shop_cd'
  }
}

const actions = {
  // setAnalyzeCode ({ commit }, payload) {
  //   commit('setAnalyzeCode', payload)
  // },
  setConstData ({ commit }, payload) {
    commit('setConstData', payload)
  },
  setCondition ({ commit }, payload) {
    commit('setIsSubmit', false)
    commit('setCondition', payload)
  },
  setHistoryCondition ({ state, commit, dispatch }, payload) {
    commit('setIsSubmit', false)

    payload.shop_base_code.length = 0
    commit('setCondition', payload)

    let param = {
      panelName: 'base',
      data: null,
      codeExclude: true
    }
    const analyze = state.condition.shop_base.analyze
    if (analyze.is_all === 1) {
      dispatch('submitAll', param)
    } else {
      let mode = analyze.mode
      if (mode === 'group') {
        if (analyze.group.length > 0) {
          param.data = analyze.group
          dispatch('submitGroup', param)
        }
      } else if (mode === 'category') {
        if (analyze.category.length > 0) {
          param.data = analyze.category
          dispatch('submitCategory', param)
        }
      } else if (mode === 'code') {
        if (analyze.code.length > 0) {
          param.data = analyze.code
          dispatch('submitCode', param)
        }
      } else if (mode === 'name') {
        if (analyze.name.length > 0) {
          param.data = analyze.name
          dispatch('submitName', param)
        }
      } else if (mode === 'file') {
        const paramFile = {
          panelName: 'base',
          fileName: analyze.file_name
        }
        commit('setFileName', paramFile)
      } else if (mode === 'freeword') {
        param.freeword = analyze.freeword
        if (analyze.freeword_code.length > 0) {
          param.data = analyze.freeword_code
          dispatch('submitFreeword', param)
        }
      }
    }
  },
  async submitAll ({ commit }, payload) {
    commit('setLoading', true)
    //  全店舗取得
    const res = await ApiManager.request('ShopSearch').shopSearchAll()

    if (res.data.data.length > 0) {
      const data = {
        panelName: payload.panelName,
        data: res.data.data,
        isSubmit: true
      }
      if (payload.codeExclude) {
        data.codeExclude = true
      }

      commit('setIsSubmit', data)
      commit('setCartItem', data)
      commit('setAll', payload)
    }
    commit('setLoading', false)
  },
  //  店舗グループ決定
  async submitGroup ({ commit }, payload) {
    commit('setLoading', true)
    const param = {
      id: payload.data
    }
    //  カート店舗取得
    const res = await ApiManager.request('ShopSearch').shopSearchGroup(param)

    if (res.data.data.length > 0) {
      const data = {
        panelName: payload.panelName,
        data: res.data.data,
        isSubmit: true
      }
      if (payload.codeExclude) {
        data.codeExclude = true
      }

      commit('setIsSubmit', data)
      commit('setCartItem', data)
      commit('setGroup', payload)
    }
    commit('setLoading', false)
  },
  /**
   * カテゴリーリストからカートに店舗を追加
   */
  async submitCategory ({ state, commit }, payload) {
    commit('setLoading', true)

    const param = {
      rank: 3,
      code: payload.data
    }
    //  商品コード利用
    let res = await ApiManager.request('ShopSearch').shopSearchCategory(param)

    if (res.data.data.length > 0) {
      const data = {
        panelName: payload.panelName,
        data: res.data.data,
        isSubmit: true
      }
      if (payload.codeExclude) {
        data.codeExclude = true
      }

      commit('setIsSubmit', data)
      commit('setCartItem', data)
      commit('setCategory', payload)
    }
    commit('setLoading', false)
  },
  /**
   * 店舗コード決定からカートに店舗を追加
   * @param {object} payload
   */
  async submitCode ({ state, commit }, payload) {
    commit('setLoading', true)

    const param = {
      code: []
    }
    for (let i = 0; i < payload.data.length; i++) {
      param.code[i] = {
        'shop_cd': payload.data[i]
      }
    }
    let res = await ApiManager.request('ShopSearch').shopSearchCode(param)

    if (res.data.data.length > 0) {
      const data = {
        panelName: payload.panelName,
        data: res.data.data,
        isSubmit: true
      }
      if (payload.codeExclude) {
        data.codeExclude = true
      }

      commit('setIsSubmit', data)
      commit('setCartItem', data)
      commit('setCode', payload)
    }
    commit('setLoading', false)
  },
  /**
   * 店舗名決定からカートに店舗を追加
   * @param { String } payload 店舗名
   */
  async submitName ({ state, commit }, payload) {
    commit('setLoading', true)
    const param = {
      name: payload.data
    }
    let res = await ApiManager.request('ShopSearch').shopSearchName(param)

    if (res.data.data.length > 0) {
      const data = {
        panelName: payload.panelName,
        data: res.data.data,
        isSubmit: true
      }
      if (payload.codeExclude) {
        data.codeExclude = true
      }

      commit('setIsSubmit', data)
      commit('setCartItem', data)
      commit('setName', payload)
    }
    commit('setLoading', false)
  },
  /**
   * ファイルのアイテムリストからカートに店舗を追加
   * @param { Array } payload 店舗コード
   */
  async submitFile ({ state, commit }, payload) {
    commit('setLoading', true)
    let res = await ApiManager.request('ShopSearch').shopSearchFile(payload.file)

    if (res.data.data.length > 0) {
      const data = {
        panelName: payload.panelName,
        data: res.data.data,
        isSubmit: true
      }
      if (payload.codeExclude) {
        data.codeExclude = true
      }

      commit('setIsSubmit', data)
      commit('setCartItem', data)
      commit('setFileName', payload)
    } else {
      this.dispatch('routerdata/setApiMessage', res.data.data.message)
    }
    commit('setLoading', false)
  },
  //  フリーワード検索決定
  async submitFreeword ({ state, commit }, payload) {
    commit('setLoading', true)

    const param = {
      code: []
    }
    for (let i = 0; i < payload.data.length; i++) {
      param.code[i] = {
        'shop_cd': payload.data[i]
      }
    }

    let res = await ApiManager.request('ShopSearch').shopSearchCode(param)

    if (res.data.data.length > 0) {
      const data = {
        panelName: payload.panelName,
        data: res.data.data,
        isSubmit: true
      }
      if (payload.codeExclude) {
        data.codeExclude = true
      }

      commit('setIsSubmit', data)
      commit('setCartItem', data)
      commit('setFreeword', payload)
    }
    commit('setLoading', false)
  }
}

const mutations = {
  setIsInit (state, data) {
    state.isInit = data
  },
  setLoading (state, data) {
    state.loading = data
    if (data) {
      this.dispatch('loading/loadingPagePlus')
    } else {
      this.dispatch('loading/loadingPageMinus')
    }
  },
  setConstData (state, data) {
    Object.keys(state.constData).forEach(
      key => {
        if (key in data) {
          state.constData[key] = data[key]
        } else {
          state.constData[key] = []
        }
      }
    )
    //  カテゴリ階層算出
    let maxrank = 1
    const cat = state.constData.shop_category
    for (let i = 0; i < cat.length; i++) {
      if (cat[i].rank > maxrank) {
        maxrank = cat[i].rank
      }
    }
    maxrank = maxrank - 0
    let siteMaxrank = Constants.getSite('shop_category_rank_qty')
    siteMaxrank = siteMaxrank - 0
    if (maxrank > siteMaxrank) {
      maxrank = siteMaxrank
    }
    state.constData.shopCategoryLevel = maxrank
  },
  setCondition (state, data) {
    state.condition = data
  },
  setIsSubmit (state, data) {
    if (data === false) {
      state.submit.base = false
      state.submit.target = false
    } else {
      state.submit[data.panelName] = data.isSubmit
    }
  },
  setAll (state, data) {
    state.condition['shop_' + data.panelName].analyze.is_all = 1
    state.condition['shop_' + data.panelName].analyze.mode = 'all'
  },
  setGroup (state, data) {
    state.condition['shop_' + data.panelName].analyze.group = data.data
    state.condition['shop_' + data.panelName].analyze.is_all = 0
    state.condition['shop_' + data.panelName].analyze.mode = 'group'
  },
  setCategory (state, data) {
    state.condition['shop_' + data.panelName].analyze.category = data.data
    state.condition['shop_' + data.panelName].analyze.is_all = 0
    state.condition['shop_' + data.panelName].analyze.mode = 'category'
  },
  setCode (state, data) {
    state.condition['shop_' + data.panelName].analyze.code = data.data
    state.condition['shop_' + data.panelName].analyze.is_all = 0
    state.condition['shop_' + data.panelName].analyze.mode = 'code'
  },
  setName (state, data) {
    state.condition['shop_' + data.panelName].analyze.name = data.data
    state.condition['shop_' + data.panelName].analyze.is_all = 0
    state.condition['shop_' + data.panelName].analyze.mode = 'name'
  },
  setFileName (state, data) {
    state.condition['shop_' + data.panelName].analyze.file_name = data.fileName
    state.condition['shop_' + data.panelName].analyze.is_all = 0
    state.condition['shop_' + data.panelName].analyze.mode = 'file'
  },
  setFreeword (state, data) {
    state.condition['shop_' + data.panelName].analyze.freeword = data.freeword
    state.condition['shop_' + data.panelName].analyze.freeword_code = data.data
    state.condition['shop_' + data.panelName].analyze.is_all = 0
    state.condition['shop_' + data.panelName].analyze.mode = 'freeword'
  },
  clearCartItem (state, data) {
    state.condition['shop_' + data.panelName + '_code'] = []
    state.condition['shop_' + data.panelName].analyze.code_exclude = []
    if (data.panelName === 'target') {
      state.condition.has_target = 0
    }
    state.submit[data.panelName] = false
  },
  setCartItem (state, data) {
    state.condition['shop_' + data.panelName + '_code'] = data.data
    if (!data.codeExclude) {
      state.condition['shop_' + data.panelName].analyze.code_exclude = []
    }
    if (data.panelName === 'target') {
      state.condition.has_target = 1
      state.submitSearch.target = false
    } else {
      state.submitSearch.base = false
    }
  },
  toggleCartItemExclude (state, data) {
    let items = state.condition['shop_' + data.panelName].analyze.code_exclude
    const find = items.some((val, index) => {
      if (val === data.key) {
        items.splice(index, 1)
        return true
      }
      return false
    })
    if (!find) {
      items.push(data.key)
    }
  },
  setCartAreaCode (state, data) {
    state.condition['shop_' + data.panelName].analyze.shop_area_code = data.areaCode
  },
  setCodeStatus (state, data) {
    state.condition['shop_' + data.panelName].analyze.code_status = data.status
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
